__turbopack_context__.v({
  "emptyStar": "AftZyq_emptyStar",
  "filledStar": "AftZyq_filledStar",
  "starsRow": "AftZyq_starsRow",
});
